import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import Card from './Card';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { educationContainerActions } from '../../redux/root-action';
import { analyticsTracking, videoTileHeader } from 'utils/constants';

const StyledOuterContainer = styled.div`
  background-image: linear-gradient(
    to right,
    ${tokens.ColorChartingBrightBlue700},
    ${tokens.ColorBrandInteractiveBlue}
  );
  width: 100%;
  height: 654px;
  @media only screen and (max-width: 1024px) and  (min-width: 767px){
    height: 710px
  }

  @media only screen and (min-width: 1200px) {
    display: flex;
    justify-content: center;
  }
`;

const StyledInnerContainer = styled.div`
  width: 1120px;
  height: 100%;
  @media only screen and (max-width: 1024px) {
    padding: 0px 24px 0px 24px;
    width: calc(100% - 48px);
  @media only screen and (max-width: 767px) {
    padding: 0px 16px 0px 16px;
    width:calc(100% - 32px);
  }
`;

const StyledTitle = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 32px;
  line-height: 1.19;
  letter-spacing: -0.75px;
  color: ${tokens.ColorWhite000};
  padding: 88px 0px 32px 16px;
`;

const StyledSliderContainer = styled.div`
  .slick-dots {
    margin: 24px 0px 24px 0px;
    bottom: auto;
  }
  .slick-dots li {
    height: auto;
    width: auto;
    margin: 0px 4px;
  }
  .slick-dots .slick-active .active {
    background-color: #05c3de;
  }
  .slick-slide > div > div > div:nth-of-type(2) {
    padding: 20px 40px;
  }
  @media (max-width: 768px) {
    .slick-slide > div > div {
      height: 100%;
    }
    .slick-slide > div > div > div:only-of-type {
      padding: 40px 30px;
    }
    .slick-slide > div > div > div:nth-of-type(2) {
      padding: 40px 30px;
    }
  }
`;

const StyledDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: #b4babf;
  border-radius: 50%;
`;

const videoImageMap: any = {
  RWC: tokens.AssetImageRwcVideo,
  NON_RWC: tokens.AssetImageNonRwcVideo,
  TERMINATED: tokens.AssetImageTerminatedVideo,
};

const tileData: any = {
  "Optimize Strategy": {
    cardHeader: 'Get a Social Security optimization strategy',
    cardCopy:
        'Our optimizer can help you estimate when to start taking Social Security and how much monthly income you may receive.',
    linkLabel: 'Learn About Optimizing Your Strategy',
    link: '/workplace/en/participant/ama/social-security-education.html',
    image: `${tokens.AssetIconAppWindowPieChart}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpAdviceOptimizeStrategy}`,
  },
  Morningstar: {
    cardHeader: 'Get professional investment advice.',
    cardCopy:
      'Make more informed decisions with personalized recommendations and valuable resources from Morningstar&reg;',
    linkLabel: 'Learn More',
    link: '',
    image: `${tokens.AssetIconMorningstarLogo}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpAdviceMorningstar}`,
  },
  'Financial Engines': {
    cardHeader: 'Get personalized investment strategies.',
    cardCopy: 'Take advantage of investment recommendations along with access to education and research.',
    linkLabel: 'Learn More',
    link: '',
    image: `${tokens.AssetIconFinancialenginesLogo}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpAdviceFE}`,
  },
  'Investing Basics': {
    cardHeader: 'Investing Basics: A Quick Primer',
    cardCopy: ' Learn the basic investing terms and principles to make the most of your savings.',
    linkLabel: 'Read Now',
    link: '',
    image: `${tokens.AssetImageInvestingBasics}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpAdviceInvestingBasics}`,
  },
  'planning tile': {
    cardHeader: 'Check out the Planning Center',
    cardCopy: 'Discover relevant tools and resources on everything from financial wellness to retirement.',
    linkLabel: 'Explore Now',
    link: '',
    image: `${tokens.AssetIconDollarBadge}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpPlanningPage}`,
  },
  'Managed Lifetime Income': {
    cardHeader: 'Explore a retirement income solution with lifelong monthly payouts',
    cardCopy: 'Managed Lifetime Income combines an investment strategy and insurance contract to offer approximately equal monthly payouts for life.',
    linkLabel: 'Explore Managed Lifetime Income',
    link: '/workplace/en/participant/managed-lifetime-income.html?planNumber='  +  localStorage.getItem("planNumber"),
    image: `${tokens.AssetIconPaperDollarPencilSign}`,
    analyticsId: `${analyticsTracking.RIXNeedMoreHelpManagedLifetimeIncome}`,
  },
  'Managed Payout Program': {
      cardHeader: 'Discover a withdrawal strategy with predictable monthly income',
      cardCopy: 'The Managed Payout Program uses managed payout investments to provide predictable monthly payouts during retirement.',
      linkLabel: 'Explore Managed Payout Program',
      link: '/workplace/en/participant/managed-payout-investments.html?planNumber=' + localStorage.getItem("planNumber"),
      image: `${tokens.AssetIconPaperDollarPencilSign}`,
      analyticsId: `${analyticsTracking.RIXNeedMoreHelpManagedPayoutProgram}`,
  },
};

class EducationContainer extends Component<any> {
  props: any;
  state: any;

  componentDidMount() {
    const { fetchVideoUrl, getFinancialWellnessTiles, getNavigationOptions, fetchTilesInformation, fetchDistroTilesInformation } = this.props;
    fetchVideoUrl();
    getFinancialWellnessTiles();
    getNavigationOptions();
    fetchTilesInformation();
    fetchDistroTilesInformation();
  }

  getTiles = () => {
    const { tilesInformation, distroTilesInformation } = this.props;

    let mliEligibility = distroTilesInformation?.profileOptions?.["Managed Lifetime Income"]?.eligibility ?? 'NOT_ELIGIBLE';
    let mppEligibility = distroTilesInformation?.profileOptions?.["Managed Payouts"]?.eligibility ?? 'NOT_ELIGIBLE';

    const tiles: any = [];
    let fwtiles = [];
    let distroTiles = [];

    if (!tilesInformation.accountLandingUrl) {
      return [];
    }

    if (tilesInformation['navigationOptions']) {
      tilesInformation['navigationOptions'].forEach((tile: any) => {
        let tileName = '';
        if (tile.name.indexOf('Morningstar') !== -1) {
          tileName = 'Morningstar';
        } else if (tile.name.indexOf('Financial Engines') !== -1) {
          tileName = 'Financial Engines';
        } else if (tile.name.indexOf('Investing Basics') !== -1) {
          tileName = 'Investing Basics';
        }

        if (!tileName) {
          return;
        }

        tiles.push(
          <Card
            cardHeader={tileData[tileName].cardHeader}
            cardCopy={tileData[tileName].cardCopy}
            linkLabel={tileData[tileName].linkLabel}
            link={tile.navigationUrl}
            image={tileData[tileName].image}
            analyticsId={tileData[tileName].analyticsId}
            key={tileData[tileName].analyticsId}
          />,
        );
      });

      // TODO: Inject tile data into the tilesInformation object.

      tiles.splice(0,0,
          <Card
              cardHeader={tileData["Optimize Strategy"].cardHeader}
              cardCopy={tileData["Optimize Strategy"].cardCopy}
              linkLabel={tileData["Optimize Strategy"].linkLabel}
              link={tileData["Optimize Strategy"].link}
              image={tileData["Optimize Strategy"].image}
              analyticsId={tileData["Optimize Strategy"].analyticsId}
              key={tileData["Optimize Strategy"].analyticsId}
          />
      )
    }

    fwtiles = tilesInformation['financialWellnessTiles']
      ? tilesInformation['financialWellnessTiles'].map(
          ({ title, header, body, buttonText, buttonURL, imageURL }: any) => (
            <Card
              cardHeader={header.replace(/(<([^>]+)>)/gi, '')}
              cardCopy={body.replace(/(<([^>]+)>)/gi, '').replace(/&amp;/gi, '&')}
              linkLabel={buttonText}
              link={buttonURL}
              imageURL={imageURL}
              key={title}
              analyticsId={title
                .replace(/\s+/g, '-')
                .replace('&', 'n')
                .toLowerCase()}
            />
          ),
        )
      : [];

    const videoTile = tilesInformation['videoUrlResponse'] && (
      <Card
        cardHeader={videoTileHeader[tilesInformation['videoUrlResponse'].type] || ''}
        isVideo={true}
        image={videoImageMap[tilesInformation['videoUrlResponse'].type]}
        linkLabel="Watch Now"
        analyticsId={analyticsTracking.RIXNeedMoreHelpVideoConfidenceCheckin}
      />
    );

    if (mppEligibility !== 'NOT_ELIGIBLE') {
      const managedPayoutProgramTile = (
          <Card
              cardHeader={tileData['Managed Payout Program'].cardHeader}
              cardCopy={tileData['Managed Payout Program'].cardCopy}
              linkLabel={tileData['Managed Payout Program'].linkLabel}
              link={tileData['Managed Payout Program'].link}
              image={tileData['Managed Payout Program'].image}
              analyticsId={tileData['Managed Payout Program'].analyticsId}
          />
      );

      distroTiles.push(managedPayoutProgramTile);

    }

    if (mliEligibility !== 'NOT_ELIGIBLE') {
      const managedLifetimeIncomeTile = (
          <Card
              cardHeader={tileData['Managed Lifetime Income'].cardHeader}
              cardCopy={tileData['Managed Lifetime Income'].cardCopy}
              linkLabel={tileData['Managed Lifetime Income'].linkLabel}
              link={tileData['Managed Lifetime Income'].link}
              image={tileData['Managed Lifetime Income'].image}
              analyticsId={tileData['Managed Lifetime Income'].analyticsId}
          />
      );

      distroTiles.push(managedLifetimeIncomeTile);
    }

    const planningTile = (
      <Card
        cardHeader={tileData['planning tile'].cardHeader}
        cardCopy={tileData['planning tile'].cardCopy}
        linkLabel={tileData['planning tile'].linkLabel}
        link={tilesInformation.accountLandingUrl}
        image={tileData['planning tile'].image}
        analyticsId={tileData['planning tile'].analyticsId}
      />
    );

    if (distroTiles.length > 0) {
      return [this.insertDistroTilesInTiles(tiles, distroTiles), ...fwtiles, videoTile, planningTile];
    } else {
      return [...tiles, ...fwtiles, videoTile, planningTile];
    }

  };

  insertDistroTilesInTiles = (tiles:any, distroTiles:any) => {
    if (distroTiles.length > 0) {
      tiles.splice(1, 0, distroTiles[0]);
    }

    if (distroTiles.length > 1) {
      tiles.splice(2, 0, distroTiles[1]);
    }

    return tiles;
  }

  render(): JSX.Element {
    const { tilesInformation } = this.props;

    return (
      <React.Fragment>
        {tilesInformation['navigationOptions'] ? (
          <StyledOuterContainer id={`education-container`}>
            <StyledInnerContainer id={`education-container-inner`}>
              <StyledTitle id={`education-container-title`}>Need more help?</StyledTitle>
              <StyledSliderContainer id={`education-container-slider`}>
                <Slider
                  speed={500}
                  slidesToShow={3}
                  slidesToScroll={3}
                  dots={true}
                  arrows={false}
                  appendDots={dots => <ul>{dots}</ul>}
                  customPaging={() => <StyledDot className="active" />}
                  responsive={[
                    {
                      breakpoint: 1025,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      },
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                      },
                    },
                  ]}
                >
                  {this.getTiles()}
                </Slider>
              </StyledSliderContainer>
            </StyledInnerContainer>
          </StyledOuterContainer>
        ) : (
          <div></div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ educationContainer }: any) => {
  return {
    financialWellnessTiles: educationContainer.financialWellnessTiles,
    navigationOptions: educationContainer.navigationOptions,
    videoData: educationContainer.videoData,
    tilesInformation: educationContainer.tilesInformation,
    distroTilesInformation: educationContainer.distroTilesInformation,
  };
};

export default connect(mapStateToProps, {
  fetchVideoUrl: educationContainerActions.fetchVideoUrl,
  getFinancialWellnessTiles: educationContainerActions.fetchFinancialWellnessTiles,
  fetchTilesInformation: educationContainerActions.fetchTilesInformation,
  getNavigationOptions: educationContainerActions.fetchNavigationOptions,
  fetchDistroTilesInformation: educationContainerActions.fetchDistroTilesInformation,
})(EducationContainer);
